function setup(root = document) {
  root.querySelectorAll('[data-ed-gallery]').forEach(gallery => {
    if (gallery.dataset.edReady) return;
    gallery.dataset.edReady = 'true';
    const section = gallery.closest('.mr-ed');
    const previous = section.querySelector('[data-ed-prev]');
    const next = section.querySelector('[data-ed-next]');
    const move = direction => {
      const card = gallery.firstElementChild;
      if (!card) return;
      gallery.scrollBy({left:direction * (card.getBoundingClientRect().width + 8),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    };
    const update = () => {
      previous.disabled = gallery.scrollLeft <= 2;
      next.disabled = gallery.scrollLeft + gallery.clientWidth >= gallery.scrollWidth - 2;
    };
    previous.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
    gallery.addEventListener('keydown',event=>{
      if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}
    });
    gallery.addEventListener('scroll',update,{passive:true});
    new ResizeObserver(update).observe(gallery);
    update();
  });
}
setup();
document.addEventListener('shopify:section:load',event=>setup(event.target));
